export const fr = {
    languages: {
        cs: 'Tchèque',
        de: 'Allemand',
        en: 'Anglais',
        es: 'Espagnol',
        fr: 'Français',
        hr: 'Croate',
        hu: 'Hongrois',
        it: 'Italien',
        nl: 'Néerlandais',
        pl: 'Polonais',
        ru: 'Russe',
        sk: 'Slovaque',
        tr: 'Turc',
        uk: 'Ukrainien',
        undefined: 'Pas de sous-titres',
    },
    player: {
        content: {
            notFound: { title: "Erreur lors du chargement de l'élément multimédia 😞" },
        },
        controls: {
            backwards: { title: '10s en arrière' },
            buffering: { title: 'Chargement...' },
            captions: { title: 'Sous-titres' },
            forwards: { title: '10s en avant' },
            fullscreen: { title: 'Plein écran' },
            pause: { title: 'Pause' },
            play: { title: 'Lecture' },
            playlist: { title: 'Liste de lecture' },
            volume: { title: 'Volume' },
        },
    },
};
